export default "__VITE_ASSET__DzReyfA7__"